import React from 'react';
import { Img } from 'component/FrameL';
import ReactMarkdown from 'react-markdown';

import './style.css';

export default ({ cmsData, className }) => {
    let { SidePhoto, Heading, Description, Links = [], BackgroundPhoto } = cmsData;
    SidePhoto = SidePhoto || {};
    
    const backgroundImageStyle = BackgroundPhoto?.url ? {
        backgroundImage: `url(${process.env.REACT_APP_API_DOMAIN + BackgroundPhoto.url})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        marginTop: 0,
        padding: 'var(--s4) 0'
    } : {};

    return <div className={`introduction-banner__container ${className}`} style={backgroundImageStyle}>
        <Img Image={SidePhoto} className="object-contain" />
        <stack-l class="justify-center" role="contentinfo" aria-label={Heading}>
            {Heading && <h3 className="text-center uppercase">{Heading}</h3>}
            <ReactMarkdown className="text-justify">{Description}</ReactMarkdown>
            <cluster-l>
                <div>
                    {Links.map(({MainText, SecondaryText}, i) => <a href={SecondaryText}>{MainText}</a>)}
                </div>
            </cluster-l>
        </stack-l>
    </div>;
};
